import { useState } from "react";
import styles from '../../css/payments/explore-pricing.module.css'
import DownArrow from '../../../images/down-arrow-circle.svg';
import { RewardsBGColors, PriceSavingColors } from "../../../Colors";
import { SelectPlanButton } from "./SelectPlanButton";

const PRICE_ID = process.env.REACT_APP_STRIPE_SUBSCRIPTION_PRICE_2;
const PRICE_AMOUNT = 22;

const borderAccentColors = {
    'morning': "linear-gradient(rgb(75, 124, 206), rgb(165, 133, 153))",
    'afternoon': "rgba(255, 255, 255, 0.3)",
    'evening': "linear-gradient(rgb(75, 124, 206), rgb(165, 133, 153))",
    'night': "linear-gradient(to top, rgb(87, 1, 83), rgb(11, 148, 161))"
}

const cardAccentColors = {
    'morning': "linear-gradient(rgb(81, 143, 248), rgb(202, 153, 183))",
    'afternoon': "linear-gradient(to bottom right, rgb(242, 129, 74), rgb(242, 201, 76))",
    'evening': "linear-gradient(rgb(81, 143, 248), rgb(202, 153, 183))",
    'night': "linear-gradient(to top, rgb(54, 0, 51), rgb(11, 135, 147))"
}

export const PremiumPriceTileDesktop = ({ timeOfDay }) => {
    return (
        <div className={styles.pricesContainerOuter} style={{ background: borderAccentColors[timeOfDay], padding: "0.5rem" }}>
            <span className={styles.badge}>Peak Pick</span>
            <div className={styles.pricesContainerInner} style={{ background: cardAccentColors[timeOfDay], padding: "1rem 1.5rem" }}>
                <div className={styles.planHeader}>
                    <p className={styles.planTitle}>GROWTH MINDSET</p>
                </div>
                <div className={styles.priceSection}>
                    <span className={styles.price}>${PRICE_AMOUNT}</span>
                    <span className={styles.billingCycle}>/ month</span>
                </div>
                <p className={styles.savings} style={{ color: PriceSavingColors[timeOfDay], marginBottom: "0.25rem" }}>
                    Human touch.<br />Deeper reflection
                </p>
                <hr className={styles.divider} />

                <ul className={styles.featuresList}>
                    <li>Unlimited Flows</li>
                    <li style={{ whiteSpace: "nowrap" }}>4 weeks of insights</li>
                    <li>1 monthly work big picture</li>
                    <li>Personalized support</li>
                    <li>1 reflection call each month to help you get the most out of your data</li>
                </ul>
                <SelectPlanButton
                    extraStyles={{ marginBottom: "1.5rem" }}
                    buttonText={'CONTINUE WITH PLAN'}
                    stripePriceId={PRICE_ID}
                />
            </div>
        </div>
    )
}

export const PremiumPriceTileMobile = ({ timeOfDay }) => {
    const [showFeatures, setShowFeatures] = useState(false);

    const getBorderColor = (timeOfDay) => {
        if (timeOfDay === 'night') {
            return borderAccentColors[timeOfDay];
        }
        else if (timeOfDay === 'evening') {
            return 'linear-gradient(to bottom, #679df8, #bc96ad)';
        }

        return RewardsBGColors[timeOfDay];
    }

    const borderColor = timeOfDay !== 'night' ? RewardsBGColors[timeOfDay] : borderAccentColors[timeOfDay];

    return (
        <div
            className={styles.pricesContainerMobile}
            style={{ background: getBorderColor(timeOfDay) }}
        >
            <span className={`${styles.badge} ${styles.badgeMobile}`}>Peak Pick</span>
            <div className={styles.pricesContainerInnerMobile} style={{ background: cardAccentColors[timeOfDay] }} onClick={() => setShowFeatures(!showFeatures)}>
                <div className={styles.headingSection}>
                    <div className={styles.planDescriptionSectionMobile}>
                        <h2 className={styles.planTitleMobile}>GROWTH MINDSET</h2>
                        <p className={styles.seeMoreText}>With dedicated support</p>
                    </div>
                    <div className={styles.pricingSectionMobile}>
                        <h3 className={styles.priceMobile} style={{ fontSize: "2.05rem" }}>${PRICE_AMOUNT}</h3>
                        <hr className={styles.priceDividerMobile} />
                        <p className={styles.billingCycleMobile}>month</p>
                    </div>
                </div>
                <div>
                    <hr className={styles.divider} />
                    <ul className={`${styles.featuresList} ${styles.featuresListMobile}`}>
                        <li>Unlimited flows</li>
                        <li>4 weeks of insights
                            <span
                                style={{
                                    opacity: !showFeatures ? 1 : 0,
                                    transition: "opacity 0.2s 0.2s",
                                    pointerEvents: !showFeatures ? "auto" : "none"
                                }}
                            >
                                &nbsp;& more
                                <img
                                    src={DownArrow}
                                    width={16}
                                    style={{ marginLeft: "0.5rem" }}
                                />
                            </span>
                        </li>
                        <div className={showFeatures ? `${styles.dropdownOpen}` : `${styles.dropdownClosed}`}>
                            <li>1 monthly work big picture</li>
                            <li>1 reflection call each month to maximize your takeaways</li>
                        </div>
                    </ul>
                    <SelectPlanButton
                        extraStyles={{ marginTop: 0, fontSize: "0.8rem" }}
                        buttonText={'CONTINUE WITH PLAN'}
                        stripePriceId={PRICE_ID}
                    />
                </div>
            </div>
        </div>
    )
}